export default {
  name: 'Logo',
  data () {
    return {
      imgUrl: '/theme/logo.png'
    }
  },
  methods: {
    useDefaultImage () {
      this.imgUrl = '/src/assets/img/logo.png'
    }
  },
  props: [
    'primaryColor',
    'title'
  ]
}



// WEBPACK FOOTER //
// ./src/assets/pages/Logo/Logo.js